import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import SignIn from '../pages/SignIn';
import ForgotPassword from '../pages/ForgotPassword';
import Dashboard from '../pages/Dashboard';
import Admin from '../pages/Admin';

const Routes = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/admin" exact component={Admin} />
      <Route path="/dashboard" component={Dashboard} isPrivate />
      <Route path="/resetar-senha" component={ForgotPassword} isGuest />
    </Switch>
  );
};

export default Routes;
